<template>
    <div>
        <form class="content-box bg-white-like mb-5 pb-5 lh-sm create-address"
              @submit.prevent="poi_data.id ?  submitEdit() : submitCreate()" id="addressForm">
            <p class="row lh-sm bg-darkRed text-white p-3" v-if="errors.global">
                Il y a une erreur dans votre formulaire, veuillez corriger comme indiqué.
            </p>

            <p class="row lh-sm">
                Avant d'ajouter une adresse, merci de vérifier qu'elle n'existe pas déjà. Le site
                Justacoté ne référence pas les sites Internet, ni les services B2B. N'ajoutez pas de fausses adresses,
                elles sont vérifiées par un modérateur.
            </p>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-12 col-md-4 mb-2 mb-md-0" for="poi-name">Nom* :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-name" type="text" v-model="poi_data.name">
                    <div v-if="errors.name" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.name" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-category">Rubrique(s)* :</label>
                <div class="col-12 col-md-8 px-0">
                    <div class="position-relative select-wrapper">
                        <select name="poi-category" id="poi-category" class="form-input form-input-select classic"
                                v-model="subcategoryId" @change="addToCategoryList(subcategoryId)">
                            <option selected disabled>Sélection des rubriques</option>
                            <template v-for="category in this.categories">
                                <option disabled>{{ category.name }}</option>
                                <option v-for="subcategory in category.subcategories" :value="subcategory.id"
                                        v-model="categoryList"
                                        :disabled="(categoryList[0] && categoryList[0].id === subcategory.id) || (categoryList[1] && categoryList[1].id === subcategory.id) || (categoryList[2] && categoryList[2].id === subcategory.id)">
                                    &nbsp&nbsp{{ subcategory.name }}
                                </option>
                            </template>
                        </select>

                        <div v-if="errors.subcategories" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.subcategories" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>

                    <div v-for="categoryItem in categoryList"
                         class="d-flex align-items-end justify-content-between my-2 px-3 px-md-0">
                        <p class="mb-0">{{ categoryItem.name }}</p>
                        <button type="button" class="btn btn-red lh-0 px-2 py-0"
                                @click.prevent="deleteFromCategoryList(categoryItem.id)">Supprimer
                        </button>
                    </div>
                    <p v-if="Object.keys(this.categoryList).length === 3" class="darkred small mt-3">Vous avez atteint
                        le maximum de catégories autorisé</p>
                </div>
            </div>

            <div class="row mb-4 align-items-center ">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-address">N° et rue
                    <span
                        class="description-tooltip-icon btn px-1 py-0 fw-bold fs-17px lh-sm tooltip-container tooltipTrigger"
                        id="tooltipTrigger100">
                        ?
                        <span id="tooltip100" class="tooltip-box tooltip-box-position black fw-normal text-center hide">Exemple : 10 rue rivoli (sans code postal ni ville)</span>
                    </span>
                    * :
                </label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-address" type="text" v-model="poi_data.street"
                           @keyup="checkAddress()">
                    <div v-if="errors.street" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.street" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-12 col-md-4 mb-2 mb-md-0" for="poi-address-extra">Complément :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-address-extra" type="text"
                           v-model="poi_data.extra">
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-city">Ville* :</label>
                <div class="d-flex flex-row col-12 col-md-8 px-0">
                    <div class="position-relative me-2 flex-grow-1">
                        <input class="form-input form-input-text" autocomplete="off" id="poi-city" type="text"
                               v-model="poi_data.city.name" @keyup="getCity()">
                        <ul v-show="citiesSuggestionsList"
                            class="list-unstyled position-absolute cities-suggestions-list">
                            <li v-for="item of this.citiesSuggestionsList" class="m-1"
                                @click="setCity(item.id, item.name, item.postal_code)">
                                {{ item.name + ' ' + item.postal_code }}
                            </li>
                        </ul>
                    </div>
                    <input class="form-input form-input-text flex-grow-0 readonly-input" style="width: 100px;"
                           autocomplete="off" type="text" v-model="poi_data.city.postcode" readonly>
                </div>
                <div v-if="errors.city_id" class="bg-darkRed text-white mb-3 mt-2 p-2 col-12">
                    <p v-for="error of this.errors.city_id" class="lh-sm mb-0">{{ error }}</p>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-phone">Téléphone* :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-phone" type="text" v-model="poi_data.phone"
                           @keyup="checkPhoneNumber">
                    <div v-if="errors.phone" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.phone" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-email">Adresse e-mail :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-email" type="email" v-model="poi_data.email">
                    <div v-if="errors.email" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.email" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-website">Site Internet :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-website" type="url" value="https://"
                           v-model="poi_data.website">
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-facebook">Facebook :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-facebook" type="url" value="https://"
                           v-model="poi_data.facebook">
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-twitter">Twitter :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-twitter" type="url" value="https://"
                           v-model="poi_data.twitter">
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-instagram">Instagram :</label>
                <div class="col-12 col-md-8 px-0">
                    <input class="form-input form-input-text" id="poi-instagram" type="url" value="https://"
                           v-model="poi_data.instagram">
                </div>
            </div>

            <div class="row mb-4 align-items-start">
                <div class="fw-bold fs-17px col-md-4 mb-2 mb-md-0">Horaires :</div>
                <div class="col-md-8 px-0 ps-3 ps-md-0 table-responsive-md">
                    <table class="table table-striped time-table">
                        <thead>
                        <tr class="bg-teal text-white">
                            <th scope="col">Jour</th>
                            <th scope="col">Horaires</th>
                            <th scope="col">Options</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="n in 7">
                            <td class="align-middle">{{ weekDays[n] }}</td>
                            <td v-if="poi_data.opening_hours">
                                <template v-for="opening_hour of poi_data.opening_hours">
                                    <div v-if="opening_hour.day === n" :key="'openingSegment'+opening_hour.id">
                                        <span>De</span>
                                        <input type="time" class="mx-2 mb-1 d-inline" v-model="opening_hour.open">
                                        <span> à </span>
                                        <input type="time" class="mx-2 mb-1 d-inline" v-model="opening_hour.close">
                                    </div>
                                </template>
                            </td>
                            <td class="align-middle">
                                <span class="d-inline-block icon-wrapper" @click="addRow(n)">
                                    <img src="/images/pois/picto-plus.webp" alt="ajouter la ligne">
                                </span>
                                <span class="d-inline-block icon-wrapper" @click="deleteRow(n)">
                                    <img src="/images/pois/picto-minus.webp" alt="supprimer la ligne">
                                </span>
                                <span v-if="n !== 1" class="d-inline-block icon-wrapper" @click="duplicateRow(n)">
                                    <img src="/images/pois/picto-duplicate.webp" alt="dupliquer la ligne">
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row mb-4 align-items-center checkbox-wrapper">
                <label class="form-check-label fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-home-service">
                    Service à domicile ?
                </label>
                <div class="col-12 col-md-8 ps-3 ps-md-0">
                    <input class="form-check-input" type="checkbox" id="poi-home-service"
                           v-model="poi_data.home_service">
                    <div v-if="errors.home_service" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.home_service" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-owner">Êtes-vous le propriétaire ou
                    responsable de cette entreprise ? :</label>
                <div class="col-12 col-md-8 position-relative px-0 select-wrapper">
                    <select name="poi-owner" id="poi-owner" class="form-input form-input-select classic"
                            v-model="poi_data.owner">
                        <option :value=false>Non</option>
                        <option :value=true>Oui</option>
                    </select>

                    <div v-if="errors.owner" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.owner" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div v-show="poi_data.owner">
                <p class="mb-4">En devenant membre pro, vous ne bénéficierez plus des avantages membre classique liés à
                    la communauté.</p>

                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0">Description
                        <span
                            class="description-tooltip-icon btn px-1 py-0 fw-bold fs-17px lh-sm tooltip-container tooltipTrigger"
                            id="tooltipTrigger200">
                            ?
                            <span id="tooltip200"
                                  class="tooltip-box tooltip-box-position black fw-normal text-center hide">Décrivez votre activité, ce qui vous différencie des autres, votre spécialité...</span>
                        </span>
                        * :
                    </label>

                    <div class="col-12 col-md-8 px-0">
                        <textarea class="form-input form-input-text" id="poi-description"
                                  v-model="poi_data.description"></textarea>
                        <div v-if="errors.description" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.description" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>
                </div>

                <div v-show="categoryServiceList.length > 0" class="row mb-4">
                    <p class="fw-bold fs-17px col-12">Prestations / Equipements</p>
                    <p class="">Cochez les cases correspondantes</p>
                    <label v-for="service of categoryServiceList" :for="'serviceIndex'+service.id"
                           class="col-12 col-md-6 form-check-label d-flex align-items-baseline">
                        <input type="checkbox" class="form-check-input me-2 mb-2" :id="'serviceIndex'+service.id"
                               :value="service.id" v-model="poi_data.services_list">
                        {{ service.name }}
                    </label>
                </div>

                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0">Actualité
                        <span
                            class="description-tooltip-icon btn px-1 py-0 fw-bold fs-17px lh-sm tooltip-container tooltipTrigger"
                            id="tooltipTrigger300">
                            ?
                            <span id="tooltip300"
                                  class="tooltip-box tooltip-box-position black fw-normal text-center hide">Quelles sont les nouveautés de votre entreprise ? Tenez vos clients au courant.</span>
                        </span>
                        :
                    </label>

                    <div class="col-12 col-md-8 px-0">
                        <textarea class="form-input form-input-text" id="poi-news" v-model="poi_data.news"></textarea>
                        <div v-if="errors.news" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.news" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>
                </div>

                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0">Promotions
                        <span
                            class="description-tooltip-icon btn px-1 py-0 fw-bold fs-17px lh-sm tooltip-container tooltipTrigger"
                            id="tooltipTrigger400">
                            ?
                            <span id="tooltip400"
                                  class="tooltip-box tooltip-box-position black fw-normal text-center hide">Augmentez l'attrait de votre adresse en créant une promotion spéciale Justacoté !</span>
                        </span>
                        :
                    </label>

                    <div class="col-12 col-md-8 px-0">
                        <textarea class="form-input form-input-text" id="poi-promotions"
                                  v-model="poi_data.promotions"></textarea>
                        <div v-if="errors.promotions" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.promotions" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>
                </div>

                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-enddate">Date de fin
                        <span
                            class="description-tooltip-icon btn px-1 py-0 fw-bold fs-17px lh-sm tooltip-container tooltipTrigger"
                            id="tooltipTrigger500">
                            ?
                            <span id="tooltip500"
                                  class="tooltip-box tooltip-box-position black fw-normal text-center hide">Sélectionnez la date de fin de la promotion</span>
                        </span>
                        :
                    </label>

                    <div class="col-12 col-md-8 px-0">
                        <input class="form-input form-input-text input-date" id="poi-enddate" type="date"
                               v-model="poi_data.enddate">
                        <div v-if="errors.enddate" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.enddate" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>
                </div>

                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-video">Url Vidéo
                        <span
                            class="description-tooltip-icon btn px-1 py-0 fw-bold fs-17px lh-sm tooltip-container tooltipTrigger"
                            id="tooltipTrigger600">
                            ?
                            <span id="tooltip600"
                                  class="tooltip-box tooltip-box-position black fw-normal text-center hide">Si vous avez une vidéo promotionnelle à mettre en avant, collez le lien dans ce champ</span>
                        </span>
                        :
                    </label>

                    <div class="col-12 col-md-8 px-0">
                        <input class="form-input form-input-text" id="poi-video" v-model="poi_data.video" type="text"
                               placeholder="Dailymotion et Youtube">
                        <div v-if="errors.video" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.video" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="isAdministrator ? 'd-block' : 'd-none'">
                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-keywords">Mots clés :</label>
                    <div class="position-relative d-inline-block col-12 col-md-8 px-0">
                        <input class="form-input form-input-text" autocomplete="off" id="poi-keywords"
                               v-model="poi_data.keywords" type="text" @keyup="getTag()">
                        <ul v-show="tagsSuggestionsList !== null"
                            class="list-unstyled position-absolute tags-suggestions-list">
                            <li v-for="item of this.tagsSuggestionsList" class="m-1"
                                @click="setTag(item.id, item.name)">{{ item.name }}
                            </li>
                        </ul>

                        <div v-if="this.poi_data.tags" class="mt-1">
                            <span v-for="tag in poi_data.tags" class="badge bg-secondary me-2" @click="removeTag(tag)">{{
                                    tag[1]
                                }} <i class="fa fa-trash"></i></span>
                        </div>
                    </div>
                </div>

                <div class="row mb-4 align-items-center">
                    <label class="fw-bold fs-17px col-md-4 mb-2 mb-md-0" for="poi-firm">Enseigne :</label>
                    <div class="position-relative d-inline-block col-12 col-md-8 px-0">
                        <div class="input-group">
                            <input class="form-control form-input form-input-text reset" autocomplete="off"
                                   id="poi-firm" v-model="poi_data.firm.name" type="text" @input="getFirm()">
                            <span @click="poi_data.firm.name = poi_data.firm.id = ''" class="input-group-text"
                                  id="basic-addon1">X</span>
                        </div>

                        <ul v-show="firmsSuggestionsList !== null && poi_data.firm.name"
                            class="list-unstyled position-absolute firms-suggestions-list">
                            <li v-for="item of this.firmsSuggestionsList" class="m-1"
                                @click="setFirm(item.id, item.name)">{{ item.name }}
                            </li>
                        </ul>
                        <div v-if="errors.firm_id" class="bg-darkRed text-white mb-3 mt-2 p-2">
                            <p v-for="error of this.errors.firm_id" class="lh-sm mb-0">{{ error }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <p>Si le point n'est pas correctement placé sur la carte, cliquez dessus et déplacez-le.</p>
                <map-component @updateCoordinates="updateCoordinates"
                               :list-markers="[{'latitude' : this.poi_data.latitude, 'longitude' : this.poi_data.longitude}]"
                               :zoom="15" :center="[this.poi_data.latitude, this.poi_data.longitude]"
                               :draggable="true"></map-component>
            </div>

            <slot></slot>

            <button class="btn btn-red mt-2 mt-md-0" type="submit">Valider</button>
        </form>
    </div>
</template>

<script>
import MapComponent from './Map/Index.vue'

export default {
    props: {
        categoriesData: Array,
        isAdministrator: Boolean,
        loggedUser: String,
        poi: Object,
        poiCity: Object,
        poiFirm: Object,
        poiHours: Array,
        poiServices: Array,
        poiTags: Array,
        subcategoriesData: Array,
    },

    components: {
        MapComponent
    },

    data() {
        return {
            ajaxReq: '',
            categoryList: [],
            categoryServiceList: [],
            categories: null,
            citiesSuggestionsList: null,
            errors: {
                global: false,
                city_id: null,
                description: null,
                email: null,
                enddate: null,
                extra: null,
                firm_id: null,
                home_service: null,
                name: null,
                news: null,
                owner: null,
                phone: null,
                promotions: null,
                street: null,
                subcategories: null,
                video: null,
            },
            firmsSuggestionsList: null,
            mode: null,
            poi_data: {
                city: {
                    id: null,
                    name: null,
                    postcode: null,
                },
                description: null,
                email: null,
                enddate: null,
                extra: null,
                facebook: null,
                firm: {
                    name: null,
                    id: null
                },
                home_service: false,
                id: null,
                instagram: null,
                keywords: null,
                latitude: 48.2,
                longitude: -2.2,
                name: null,
                news: null,
                opening_hours: [],
                owner: false,
                phone: null,
                promotions: null,
                services_list: [],
                street: null,
                subcategories: [],
                tags: [],
                twitter: null,
                video: null,
                website: null,
            },
            redirectUrl: '',
            subcategories: {},
            subcategoryId: null,
            tagsSuggestionsList: null,
            weekDays: {
                1: 'Lundi',
                2: 'Mardi',
                3: 'Mercredi',
                4: 'Jeudi',
                5: 'Vendredi',
                6: 'Samedi',
                7: 'Dimanche'
            },
        }
    },

    mounted() {
        this.categories = this.categoriesData;

        let data = this.subcategoriesData;
        for (const subcategory of data) {
            this.subcategories[subcategory.id] = {};
            this.subcategories[subcategory.id]['name'] = subcategory.name;
            this.subcategories[subcategory.id]['id'] = subcategory.id;
        }

        if (this.poi) {
            let poi = this.poi;
            let city = this.poiCity;
            let firm = this.poiFirm;

            this.poi_data.city = {
                id: city.id,
                name: city.name,
                postcode: city.postcode,
            }
            this.poi_data.description = poi.description;
            this.poi_data.email = poi.email;
            this.poi_data.enddate = poi.promotion_date_end;
            this.poi_data.extra = poi.address_supplement;
            this.poi_data.facebook = poi.facebook;
            this.poi_data.firm = firm ? {name: firm.name, id: firm.id} : {name: null, id: null};
            this.poi_data.home_service = poi.at_home;
            this.poi_data.id = poi.id;
            this.poi_data.instagram = poi.instagram;
            this.poi_data.keywords = null;
            this.poi_data.latitude = poi.latitude;
            this.poi_data.longitude = poi.longitude;
            this.poi_data.name = poi.name;
            this.poi_data.news = poi.news;
            this.poi_data.owner = !!(poi.owner_id === parseInt(this.loggedUser) || (this.isAdministrator && poi.owner_id));
            this.poi_data.phone = poi.phone_number;
            this.poi_data.promotions = poi.promotion;
            this.poi_data.street = poi.address;

            for (const subcategory of poi.subcategories) {
                this.addToCategoryList(subcategory.id);
            }

            this.poi_data.twitter = poi.twitter;
            this.poi_data.video = poi.video;
            this.poi_data.website = poi.website;

            if (this.poiServices) {
                for (const service of this.poiServices) {
                    this.poi_data.services_list.push(service.id);
                }
            }

            if (this.poiTags) {
                for (const tag of this.poiTags) {
                    this.poi_data.tags.push([
                        tag.id,
                        tag.name
                    ])
                }
            }
        }
        if (this.poiHours) {
            this.poi_data.opening_hours = this.poiHours;

            const opened_days = []
            for (let slot of this.poiHours) {
                opened_days.push(slot.day);
            }

            for (let i = 1; i <= 7; i++) {
                if (!opened_days.includes(i)) {
                    this.generateOpeningHoursObject(i);
                }
            }
        } else {
            for (let i = 1; i <= 7; i++) {
                this.generateOpeningHoursObject(i);
            }
        }
    },

    methods: {
        addRow(day) {
            this.generateOpeningHoursObject(day);
        },

        addToCategoryList(subcategoryId) {
            if (this.categoryList[subcategoryId] === undefined && Object.keys(this.categoryList).length < 3) {
                this.categoryList.push(this.subcategories[subcategoryId]);
                this.poi_data.subcategories.push(subcategoryId);
            }
            this.getServices();
        },

        checkAddress() {
            if (this.poi_data.street && this.poi_data.city.id) {
                this.getAddress();
            }
        },

        checkPhoneNumber() {
            if (this.poi_data.phone.includes('+') || this.poi_data.phone.startsWith('00 33') || this.poi_data.phone.startsWith('0033')) {
                this.errors.phone = ['Saisissez le numéro sans le préfixe +33 et sans extension. Par exemple : 03 20 21 22 23'];
            } else {
                this.errors.phone = null;
            }
        },

        deleteRow(day) {
            let hoursOfTheDay = this.poi_data.opening_hours.filter(x => x.day === day);
            this.poi_data.opening_hours = this.poi_data.opening_hours.filter(x => x.day !== day);

            if (hoursOfTheDay.length > 1) {
                for (let i = 0; i < hoursOfTheDay.length - 1; i++) {
                    this.poi_data.opening_hours.push(hoursOfTheDay[i]);
                }
            } else {
                this.generateOpeningHoursObject(day);
            }
        },

        deleteFromCategoryList(subcategoryId) {
            const list = this.categoryList;
            this.categoryList = [];
            for (const item of list) {
                if (item.id !== subcategoryId) {
                    this.categoryList.push(item);
                }
            }
            this.poi_data.subcategories = this.poi_data.subcategories.filter(id => id !== subcategoryId);

            this.getServices();
        },

        duplicateRow(day) {
            let duplicatedHours = this.poi_data.opening_hours.filter(x => x.day === day - 1);

            this.poi_data.opening_hours = this.poi_data.opening_hours.filter(x => x.day !== day);

            for (let hour of duplicatedHours) {
                this.generateOpeningHoursObject(day, hour.open, hour.close);
            }
        },

        generateOpeningHoursObject(day, open, close) {
            this.poi_data.opening_hours.push({
                day: day,
                open: open,
                close: close,
                id: 'TEMP' + Math.floor(Math.random() * 1000)
            })
        },

        async getAddress() {
            if (this.poi_data.street.length > 3) {
                if (this.ajaxReq) {
                    this.ajaxReq.cancel('stop');
                }
                this.ajaxReq = axios.CancelToken.source();

                await axios.get(`https://api-adresse.data.gouv.fr/search/?q=${this.poi_data.street}+${this.poi_data.city.name}&limit=1&postcode=${this.poi_data.city.postcode}`, {
                    cancelToken: this.ajaxReq.token,
                }).then((response) => {
                    this.poi_data.longitude = response.data.features[0].geometry.coordinates[0]
                    this.poi_data.latitude = response.data.features[0].geometry.coordinates[1]
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        return "axios request cancelled";
                    }

                    return error;
                })
            }
        },

        async getCity() {
            if (this.poi_data.city.name.length > 1) {
                if (this.ajaxReq) {
                    this.ajaxReq.cancel('stop');
                }

                this.ajaxReq = axios.CancelToken.source();

                await axios.get(`/api/v1/cities/${this.poi_data.city.name}`, {
                    cancelToken: this.ajaxReq.token,
                }).then((response) => {
                    this.citiesSuggestionsList = response.data;
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        return "axios request cancelled";
                    }

                    return error;
                })
            }

            if (this.poi_data.city.id !== null) {
                this.poi_data.city.id = null;
                this.poi_data.city.name = null;
                this.poi_data.city.postcode = null;
            }
        },

        async getFirm() {
            if (this.poi_data.firm.name.length > 1) {
                if (this.ajaxReq) {
                    this.ajaxReq.cancel('stop');
                }

                this.ajaxReq = axios.CancelToken.source();

                await axios.get(`/api/v1/firms/${this.poi_data.firm.name}`, {
                    cancelToken: this.ajaxReq.token,
                }).then((response) => {
                    this.firmsSuggestionsList = response.data;
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        return "axios request cancelled";
                    }
                    return error;
                })
            }

            if (this.poi_data.firm.id !== null) {
                this.poi_data.firm.id = null;
                this.poi_data.firm.name = null;
            }
        },

        async getTag() {
            if (this.ajaxReq) {
                this.ajaxReq.cancel('stop');
            }

            this.ajaxReq = axios.CancelToken.source();

            await axios.get(`/api/v1/tags/${this.poi_data.keywords}`, {
                cancelToken: this.ajaxReq.token,
            }).then((response) => {
                this.tagsSuggestionsList = response.data;
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    return "axios request cancelled";
                }

                return error;
            });
        },

        async getServices() {
            axios.post(`/api/v1/services`, this.poi_data.subcategories)
                .then((response) => {
                    this.categoryServiceList = [];

                    for (const service of Object.entries(response.data)) {
                        this.categoryServiceList.push({name: service[1][0].name, id: service[1][0].id});
                    }
                }).catch((error) => {
                console.log('Erreur ! ' + error);
            })
        },

        handleErrors(error) {
            let errors = error.response.data.errors
            for (const [error_item_key, error_item] of Object.entries(errors)) {
                this.errors[error_item_key] = error_item;
            }

            this.errors.global = true;
        },

        redirect(link) {
            window.location.href = link;
        },

        setCity(cityId, cityName, cityPostcode) {
            this.poi_data.city.id = cityId;
            this.poi_data.city.name = cityName;
            this.poi_data.city.postcode = cityPostcode;
            this.citiesSuggestionsList = null;
            this.checkAddress();
        },

        setFirm(firmId, firmName) {
            this.poi_data.firm.id = firmId;
            this.poi_data.firm.name = firmName;
            this.firmsSuggestionsList = null;
        },

        setTag(id, name) {
            this.poi_data.tags.push([
                id, name
            ]);
            this.tagsSuggestionsList = null;
            this.poi_data.keywords = null;
        },

        removeTag(value) {
            let newValues = [];

            this.poi_data.tags.forEach(function (tag) {
                if (tag[0] !== value[0]) {
                    newValues.push(tag);
                }
            });

            this.poi_data.tags = newValues;
        },

        submitCreate() {
            axios.post(`/pois/store`, this.poi_data)
                .then((response) => {
                    this.redirect(response.data.link);
                })
                .catch((error) => {
                    this.handleErrors(error);

                    window.location.href = window.location.href + `#addressForm`;
                });
        },

        submitEdit() {
            axios.patch(`/pois/${this.poi_data.id}/update`, this.poi_data)
                .then((response) => {
                    this.redirect(response.data.link);
                })
                .catch((error) => {
                    this.handleErrors(error);

                    window.location.href = window.location.origin + `/pois/${this.poi_data.id}/edit#addressForm`;
                });
        },

        updateCoordinates(coordinatesReceived) {
            this.poi_data.longitude = coordinatesReceived.longitude;
            this.poi_data.latitude = coordinatesReceived.latitude;
        }
    }
};
</script>

<style scoped>
option[disabled] {
    font-weight: bold;
}

.readonly-input {
    background-color: #e9ecef;
    border-color: #ced4da;
    cursor: not-allowed;
}
</style>
